import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export interface DropdownActionItem {
    action: string;
    text: string;
    route?: string;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const Actions = (
    props: {
        id?: string | undefined;
        as?: 'icon' | undefined;
        dropDownActions: DropdownActionItem[];
        onItemClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
        variant?: string;
        containerClassName?: string;
        className?: string;
        align?: 'start' | 'end';
        buttonTitle?: string;
        buttonAriaTitle?: string;
    },
) => {
    const {
        id,
        as,
        dropDownActions,
        onItemClick,
        variant = 'flat', // default props
        containerClassName = '', // default props
        className = '', // default props
        align = undefined, // default props
        buttonTitle = 'Actions', // default props
        buttonAriaTitle = '', // default props
    } = props;

    const createDropdownItem = (itemAction: DropdownActionItem, index: number) => {
        if (itemAction.route) {
            return (
                <Dropdown.Item
                    key={`actions-dd-${id}-${index}`}
                    as={Link}
                    eventKey={index}
                    to={itemAction.route}
                >
                    {itemAction.text}
                </Dropdown.Item>
            );
        }

        return (
            <Dropdown.Item
                key={`actions-dd-${id}-${index}`}
                eventKey={index}
                onClick={itemAction.onClick || onItemClick}
            >
                {itemAction.text}
            </Dropdown.Item>
        );
    };

    return (
        <Dropdown
            align={align}
            className={`actions-menu ${containerClassName}`}
        >
            <Dropdown.Toggle
                id={`actions-dropdown-button-${id}`}
                variant={variant}
                className={`${as === 'icon' ? 'dropdown-toggle-none actions-icon' : ''} ${className}`}
            >
                {as === 'icon'
                    ? (
                        <>
                            <i className='icon-ellipsis' aria-hidden='true' role='presentation' />
                            <span className='visually-hidden'>{buttonTitle}</span>
                            <span className='visually-hidden'>{buttonAriaTitle}</span>
                        </>
                    )
                    : (
                        <>
                            <span>{buttonTitle}</span>
                            <span className='visually-hidden'>{buttonAriaTitle}</span>
                        </>
                    )}
            </Dropdown.Toggle>
            <Dropdown.Menu variant='dark'>
                {dropDownActions.map((action, index) => createDropdownItem(action, index))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

// Actions.defaultProps = {
//     variant: 'flat',
//     containerClassName: '',
//     className: '',
//     align: '',
//     buttonTitle: 'Actions',
//     buttonAriaTitle: '',
// };

export default Actions;
